<!-- 外协链地图 -->
<template>
  <div class="vip-map-wrap">
    <div
      id="container"
      v-loading="isLoading"
      element-loading-text="正在定位中......"
      element-loading-spinner="el-icon-loading"
    ></div>
    <div class="search-wrap">
      <div class="search-del">
        <div class="cur-position">
          <img
            src="@/assets/images/location-marker.png"
            alt=""
          >
          <span>{{ currentAddress.address || '正在定位中......' }}</span>
        </div>
        <el-input
          v-model="search.keyword"
          size="small"
          placeholder="请输入关键词搜索"
          clearable
          @input="onKeywordInput"
          style="width: 360px; margin-right: 10px;"
        ></el-input>
        <div class="other-search">
          <el-select
            @change="changeRadius"
            class="kilom-select"
            v-model="search.kilometre"
            size="small"
            placeholder="请选择范围"
          >
            <el-option
              v-for="item in kilometreList"
              :key="item"
              :value="item"
              :label="'周围'+item+'公里'"
            ></el-option>
          </el-select>
          <el-cascader
            :options="typeOptions"
            v-model="search.sort"
            size="small"
            :props="{checkStrictly: true,emitPath: true}"
            clearable
            placeholder="选择分类"
            :show-all-levels="false"
            @change="changeSort"
            ref="cascaderRef"
          ></el-cascader>
        </div>
      </div>
      <div class="search-res">
        <div class="tab-wrap">
          <div
            @click="tabChange(0)"
            class="tab-item"
            :class="tabIndex === 0 ? 'tab-item-active' : ''"
          >设备列表 ({{ equimpList && equimpList.length }})</div>
          <div
            @click="tabChange(1)"
            class="tab-item"
            :class="tabIndex === 1 ? 'tab-item-active' : ''"
          >企业列表 ({{ companyList && companyList.length }})</div>
        </div>
        <!-- 设备列表 -->
        <div
          class="equip-back"
          v-show="tabIndex === 0"
        >
          <template v-if="equimpList && equimpList.length">
            <div
              class="equip-wrap"
              @click="openDetail(item)"
              v-for="item in equimpList"
              :key="item.id"
            >
              <div class="left-con">
                <prod-icon
                  :src="item.equipmentImages[0].FileServerPath"
                  :width="80"
                  :height="80"
                ></prod-icon>
              </div>
              <div
                class="add-equimp"
                @click.stop="addEquimp(item)"
              >加入外协链</div>
              <div class="right-con">
                <div class="title">{{ item.equipmentName }}</div>
                <div class="address linkman">距离：{{ (item.company._distance_m / 1000).toFixed(2) }}公里</div>
                <div class="address linkman">地址：{{ item.company.address }}</div>
                <div class="linkman">联系电话：{{ item.company.phone }}</div>
              </div>
            </div>
          </template>
          <el-empty
            v-else
            description="暂无设备"
          ></el-empty>
        </div>
        <!-- 企业列表 -->
        <div
          class="equip-back"
          v-show="tabIndex === 1"
        >
          <template v-if="companyList && companyList.length">
            <div
              class="equip-wrap"
              v-for="item in companyList"
              :key="item.id"
              @click="openDetail(item)"
            >
              <div class="left-con">
                <comp-icon
                  :src="item.compLogo"
                  :width="80"
                  :height="80"
                ></comp-icon>
              </div>
              <div class="right-con">
                <div class="title">{{ item.compName }}</div>
                <div
                  class="linkman"
                  :title="item.mainProduct"
                >主营产品：{{ item.mainProduct }}</div>
                <div
                  class="address linkman"
                  :title="item.address"
                >地址：{{ item.address }}</div>
                <div class="model">联系电话：{{ item.phone }}</div>
              </div>
            </div>
          </template>
          <el-empty
            v-else
            description="暂无企业"
          ></el-empty>
        </div>
      </div>
    </div>
    <div class="search-area">
      <el-input
        v-model="searchAreaWord"
        size="small"
        placeholder="请输入想定位的地点"
        clearable
        id="tipInput"
        @input="onKeywordInput"
      ></el-input>
    </div>
    <el-drawer
      :title="tabIndex===0 ? '设备详情' : '企业详情'"
      :visible.sync="isDetailDraw"
      v-if="isDetailDraw"
      :size="810"
      @close="isDetailDraw = false"
    >
      <component
        :is="tabIndex === 0 ? 'equimpmentDetail' : 'companyDetail'"
        :id="detailId"
      ></component>
    </el-drawer>

    <!-- 选择设备 -->
    <equimpmentSelect
      v-if="directoryDialogVisible"
      :visible.sync="directoryDialogVisible"
      :equimpId="detailId"
      @confirm="onDirectoryConfirm"
      @cancel="onDirectoryCancel"
    />
  </div>
</template>

<script>
import equimpmentDetail from './equimpment-detail.vue'
import equimpmentSelect from './equimpment-select.vue'
import companyDetail from './company-detail.vue'
import { ProductService } from '@/service/outsource'
import CompIcon from "/@/components/icon/comp-icon.vue";
import ProdIcon from "/@/components/icon/prod-icon.vue";

export default {
  components: {
    equimpmentDetail,
    companyDetail,
    equimpmentSelect,
    CompIcon,
    ProdIcon
  },
  data () {
    return {
      tabIndex: 0,
      isDetailDraw: false,
      typeOptions: [], // 选择分类数据
      isLoading: false,
      equimpList: [], // 设备列表
      companyList: [], // 企业列表
      map: null,
      lnglat: [],
      circle: null,
      marker: null,
      poiMarkers: [], // 地图上用于展示搜索结果的点位集合
      currentAddress: {},
      kilometreList: [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      search: {
        kilometre: 10, // 周围几公里
        keyword: "",
        sort: []
      },
      detailId: null,
      searchTimer: null, // 防抖定时器
      directoryDialogVisible: false,
      searchAreaWord: ''
    }
  },
  mounted () {
    // 确保 AMap 脚本已加载
    if (window.AMap) {
      this.map = new window.AMap.Map('container', {
        zoom: 2
      });
      this.initMap();
    }
    this.fetchTypeOptions();
  },
  beforeDestroy () {
    // 清理防抖定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    // ------------ 切换tab
    tabChange (index) {
      this.tabIndex = index;
    },

    // ----------- 打开详情
    openDetail (row) {
      this.detailId = row.id || row.compId
      this.isDetailDraw = true;
    },

    // ------------ 防抖搜素
    onKeywordInput () {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.getEquimpList();
        this.getCompanyList();
      }, 500);
    },

    onDirectoryConfirm (directory) {
      console.log('选择的目录：', directory)
      // 处理目录选择逻辑
    },
    onDirectoryCancel () {
      console.log('取消选择')
    },

    addEquimp (row) {
      this.detailId = row.id || row.compId
      this.directoryDialogVisible = true;
    },

    // ------------ 获取设备
    async getEquimpList () {
      const res = await ProductService.equipmentList({
        cid: this.search.sort.at(-1) || 0,
        keyword: this.search.keyword,
        distance: this.search.kilometre * 1000,
        mapLng: this.lnglat[0],
        mapLat: this.lnglat[1],
        page: 1
      })
      this.equimpList = res.data.list;

      // 先清除上一次的点位
      this.clearPoiMarkers()
      // 为空直接返回，避免报错
      if (!this.equimpList || !this.equimpList.length) return

      // 画点
      for(let val of res.data.list) {
        if(val.company.mapLat) {
          // 设备固定传0
          this.drawIconPoint(0, val.company.mapLng, val.company.mapLat, {
            id: val.id
          })
        }
      }
    },

    // ------------ 获取企业
    async getCompanyList () {
      const res = await ProductService.comList({
        cid: this.search.sort.at(-1) || 0,
        keyword: this.search.keyword,
        distance: this.search.kilometre * 1000,
        mapLng: this.lnglat[0],
        mapLat: this.lnglat[1],
        page: 1
      })
      this.companyList = res.data.list;

      // // 为空直接返回，避免报错
      // if (!this.companyList || !this.companyList.length) return

      // // 画点
      // for(let val of res.data.list) {
      //   if(val.mapLat) {
      //     // 企业固定传1
      //     this.drawIconPoint(1, val.mapLng, val.mapLat, {
      //       id: val.compId
      //     }, 'https://webapi.amap.com/theme/v1.3/markers/n/mark_y.png')
      //   }
      // }
    },

    // ------------ 更改分类
    changeSort () {
      this.$refs.cascaderRef.dropDownVisible = false
      this.getEquimpList()
      this.getCompanyList()
    },

    // ------------ 初始化地图
    initMap () {
      this.isLoading = true;
      // 加载定位插件
      this.map.plugin('AMap.Geolocation', () => {
        const geolocation = new window.AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位
          position: 'RB',           // 定位按钮的停靠位置
          timeout: 5000,
          offset: [18, 100],         // 定位按钮与设置的停靠位置的偏移量
          zoomToAccuracy: true,      // 定位成功后是否自动调整地图视野到定位点
          showMarker: false, // 关键：不显示自带 marker
          showCircle: false
        });
        this.circle && this.map.remove(this.circle);
        this.map.addControl(geolocation);

        // // 添加指南针
        // AMap.plugin(['AMap.ControlBar'], () => {
        //   const controlBar = new AMap.ControlBar({
        //     position: { right: '10px', top: '10px' }
        //   });
        //   this.map.addControl(controlBar);
        // });

        // 添加放大缩小
        AMap.plugin(['AMap.ToolBar'], () => {
          const toolBar = new AMap.ToolBar();
          this.map.addControl(toolBar);
        });
        // 自动定位
        geolocation.getCurrentPosition((status, result) => {
          console.log('精准定位失败')
          console.log('status：', status)
          console.log('result：', result) 
          if (status === 'complete') {
            // 定位成功，地图中心移动到定位点
            if (!this.lnglat.length) {
              this.lnglat = [result.position.lng, result.position.lat];
            }
            this.map.setCenter(this.lnglat);

            // 添加marker
            this.addMarker(result.position);
          } else {
            // 定位失败
            // 定位失败的话就至定位到城市
            // --------- console.log 最好不要去掉，因为定位这块有很多情况，这样方便看线上定位到错误
            geolocation.getCityInfo((status, result) => {
              console.log('精准定位失败，走定位到城市逻辑')
              console.log('status', status)
              console.log('result', result) 
              try {
                this.map.setZoom(18);
                this.lnglat = result.position
                // 添加marker
                this.addMarker({
                  lng: result.position[0],
                  lat: result.position[1]
                });
              } catch(err) {
                console.log('定位到城市获取经纬度失败：', err)
                console.log('现在走直接定位到北京逻辑')
                // 如果定位完全失败，直接定位到北京
                this.$message.warning('当前设备获取定位失败，已为您自动定位到北京市');
                // 北京经纬度 [116.397428, 39.90923]
                this.map.setZoom(12);
                this.lnglat = [116.397428, 39.90923];
                this.addMarker({
                  lng: 116.397428,
                  lat: 39.90923
                });
                return;
              }
            })
          }
        });
      });
      // 注册地点搜索
      this.searchArea();
    },

    // 添加marker
    addMarker (lnglat) {
      this.isLoading = false
      if (this.marker) { this.map.remove(this.marker); this.marker = null; }
      if (this.circle) { this.map.remove(this.circle); this.circle = null; }

      // 调用设备和企业接口
      this.getEquimpList()
      this.getCompanyList()

      this.circle = new AMap.Circle({
        center: new AMap.LngLat(lnglat.lng, lnglat.lat), // 圆心坐标
        radius: this.search.kilometre * 1000, // 半径，单位：米
        strokeColor: '#1791fc', // 线颜色
        strokeOpacity: 0.4, // 线透明度
        strokeWeight: 2, // 线宽
        fillColor: '#1791fc', // 填充颜色
        fillOpacity: 0.35 // 填充透明度
      });
      // 让地图自适应圆的范围
      this.map.setFitView([this.circle]);
      // 将圆形添加到地图上
      this.map.add(this.circle);

      this.marker && this.map.remove(this.marker)

      // 可选：添加一个 marker
      this.marker = new window.AMap.Marker({
        position: [lnglat.lng, lnglat.lat],
        map: this.map,
        icon: require("@/assets/images/location-marker.png"),
        offset: new window.AMap.Pixel(0, 0), // 使圆点居中
        anchor: 'center'
      });

      var geocoder = new AMap.Geocoder({
        radius: 1000
      });
      geocoder.getAddress(this.lnglat, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.$set(this.currentAddress, 'address', result.regeocode.formattedAddress);
        } else {
          console.log('根据经纬度查询地址失败', status, result)
        }
      });
    },
    // 更改半径
    changeRadius (value) {
      this.map.remove(this.circle);

      this.circle = new AMap.Circle({
        center: new AMap.LngLat(this.lnglat?.[0], this.lnglat?.[1]), // 圆心坐标
        radius: value * 1000, // 半径，单位：米
        strokeColor: '#1791fc', // 线颜色
        strokeOpacity: 0.4, // 线透明度
        strokeWeight: 2, // 线宽
        fillColor: '#1791fc', // 填充颜色
        fillOpacity: 0.35 // 填充透明度
      });
      // 让地图自适应圆的范围
      this.map.setFitView([this.circle]);
      // 将圆形添加到地图上
      this.map.add(this.circle);

      this.getEquimpList()
      this.getCompanyList()
    },
    // 搜索地点实现
    searchArea () {
      // 注册搜索地点框
      this.map.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], () => {
        let auto = new AMap.AutoComplete({
          input: "tipInput"
        });
        // 不将搜索结果渲染到地图，避免展示默认的红色 POI 标记
        let placeSearch = new AMap.PlaceSearch();
        // placeSearch.setMap(null);
        //注册监听，当选中某条记录时会触发
        auto.on("select", async (e) => {
          // 清理可能残留的结果覆盖物
          placeSearch.clear && placeSearch.clear();
          placeSearch.setCity(e.poi.adcode);
          placeSearch.search(e.poi.name);  //关键字查询查询

          // 如果没有经纬度返回/正向地理编码获取经纬度（地址 → 经度纬度）
          if (!e.poi.location.lng) {
            const pos = await this.getLngLatByAddress(e.poi.district + e.poi.name, e.poi.adcode); // 或传 '360300'
            this.lnglat = [pos.lng, pos.lat]
          } else {
            this.lnglat = [e.poi.location.lng, e.poi.location.lat]
          }

          this.currentAddress.address = e.poi.district + e.poi.name
          // 定位成功，地图中心移动到定位点
          this.map.setCenter(this.lnglat);
          // 添加marker
          this.addMarker({
            lng: this.lnglat[0],
            lat: this.lnglat[1]
          });

          setTimeout(() => {
            this.changeRadius(this.search.kilometre)
          }, 500)
        });
      });
    },

    // 支持传图片的方法
    // 传本地图标：iconUrl = require('@/assets/images/location-marker.png') 
    // type: 0 代表是设备，1代表是企业
    drawIconPoint(type = 0, lng, lat, options = {}, iconUrl = 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png') {
      if (!this.map || typeof AMap === 'undefined') return null;
      const { id, zIndex = 120, anchor = 'center', offset = new AMap.Pixel(0, 0) } = options;
      const marker = new AMap.Marker({
        position: [lng, lat],
        icon: iconUrl,
        anchor,
        offset,
        zIndex,
        map: this.map,
      });
      // 把业务 id 放到扩展数据里
      marker.setExtData({id});
      // 记录到集合，便于下次清理
      this.poiMarkers.push(marker)
      // 点击事件：优先走自定义回调，否则走默认请求
      marker.on('click', (evt) => {
        const { id } = evt.target.getExtData() || {};
        if (!id) return;

        if (typeof onClick === 'function') {
          onClick(id, evt);
          return;
        }

        // 打开详情
        this.tabIndex = 0
        this.detailId = id
        this.isDetailDraw = true
      });

      return marker;
    },

    // 清除业务点位
    clearPoiMarkers () {
      if (this.poiMarkers && this.poiMarkers.length) {
        this.map.remove(this.poiMarkers)
        this.poiMarkers = []
      }
    },

    // 正地理编码（地址 -> 经纬度）
    getLngLatByAddress (address, cityOrAdcode) {
      return new Promise((resolve, reject) => {
        AMap.plugin('AMap.Geocoder', () => {
          const geocoder = new AMap.Geocoder({
            city: cityOrAdcode || '全国', // 建议传入城市/adcode 以提高命中率
          });
          geocoder.getLocation(address, (status, result) => {
            if (status === 'complete' && result.geocodes && result.geocodes.length) {
              const { location } = result.geocodes[0]; // 最优匹配
              resolve({ lng: location.lng, lat: location.lat, raw: result.geocodes[0] });
            } else {
              reject(new Error('地址解析失败：' + (result && result.info)));
            }
          });
        });
      });
    },


    // ----------- 获取并组装分类数据
    async fetchTypeOptions () {
      const dataList = await ProductService.getClassAllComposes([3])
      // 适配 el-cascader
      this.typeOptions = this.adaptForCascader(this.listToTree(dataList));

      // 默认选中第一级的第一个子级
      if (this.typeOptions.length > 0) {
        // 如果第一级有子级，则选中第一个子级
        if (this.typeOptions[0].children?.length > 0) {
          // 默认选中
          // this.search.sort = [
          //   this.typeOptions[0].value,
          //   this.typeOptions[0].children[0].value
          // ];
        } else {
          // 如果没有子级，只选中第一级
          // this.search.sort = [this.typeOptions[0].value];
        }
      }
    },

    /**
     * 适配 el-cascader 组件的数据格式
     * @param {Array} tree - 树形结构数据
     * @param level - 超出几级就忽略后面的层级，目前是4级
     * @returns {Array} 适配后的数据
     */
    adaptForCascader (tree, level = 1) {
      return tree.map(node => {
        const adapted = {
          label: node.CName, // el-cascader 需要的 label 字段
          value: node.CID,    // el-cascader 需要的 value 字段
        };
        // 如果有子节点，递归适配
        if (node.children && node.children.length > 0) {
          adapted.children = this.adaptForCascader(node.children, level + 1);
        }
        return adapted;
      });
    },
    /**
     * 将扁平化的列表数据转换为树形结构
     * @param {Array} list - 原始数据列表
     * @param {String} idKey - 节点唯一标识字段名，默认 'id'
     * @param {String} pIdKey - 父节点字段名，默认 'pId'
     * @param {String} children - 子节点字段名，默认 'children'
     * @returns {Array} 树形结构数组
     */
    listToTree (list, idKey = 'CID', pIdKey = 'ParentID', children = 'children') {
      const nodeMap = {}; // 用于存储所有节点的映射关系
      const tree = [];    // 最终的树形结构
      // 先遍历一遍，将所有节点放入 nodeMap，并初始化 children 数组
      list.forEach(item => {
        nodeMap[item[idKey]] = { ...item, [children]: [] };
      });
      // 再遍历一遍，根据 pIdKey 组装父子关系
      list.forEach(item => {
        const node = nodeMap[item[idKey]];
        if (item[pIdKey] && nodeMap[item[pIdKey]]) {
          // 如果有父节点，则加入父节点的 children
          nodeMap[item[pIdKey]][children].push(node);
        } else {
          // 没有父节点则为根节点
          tree.push(node);
        }
      });
      return tree;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  color: black;
  font-size: 18px;
}
  .search-area {
   position: absolute;
   top: 30px;
   left: calc(50% - 115px);
   background: white;
   border-radius: 6px;
   /deep/ .el-input__inner {
     width: 230px;
     height: 35px;
     font-size: 14px;
     box-shadow: #69708d 0px 0px 5px;
   }
 }
 .vip-map-wrap {
  padding: 10px;
  position: relative;

  .add-equimp {
    position: absolute;
    border-radius: 20px;
    padding: 4px 7px;
    font-size: 12px;
    right: 25px;
    margin-top: -68px;
    color: #0b83ff;
    cursor: pointer;
  }
  .linkman {
    width: 248px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  #container {
    width: 100%;
    height: calc(100vh - 90px);
  }
  .search-wrap {
    position: absolute;
    top: 30px;
    left: 30px;
    width: 400px;
    z-index: 1;
    .search-del {
      width: 100%;
      background: white;
      box-shadow: #e1e2e6 0px 0px 5px;
      border-radius: 6px;
      padding: 20px 20px 10px 20px;
      font-size: 14px;
      .cur-position {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 5px;
        }
        span {
          width: 375px;
          overflow: hidden; //超出文本隐藏
          white-space: nowrap;
          text-overflow: ellipsis; ///超出部分省略号显示
        }
      }
      .other-search {
        margin-top: 10px;
        display: flex;
        flex: 1;
        align-items: center;
        .kilom-select {
          margin-right: 60px;
        }
        /deep/ .el-input__inner {
          border: none;
        }
      }
    }
    .search-res {
      width: 100%;
      background: white;
      box-shadow: #e1e2e6 0px 0px 5px;
      border-radius: 6px;
      margin-top: 10px;
      font-size: 14px;
      color: gray;

      .tab-wrap {
        display: flex;
        padding: 20px 0 20px 20px;

        .tab-item {
          color: rgb(97, 97, 97);
          cursor: pointer;
          margin-right: 15px;
        }
        .tab-item-active {
          font-weight: bold;
          color: #333;
        }
      }
      .equip-back {
        max-height: calc(100vh - 340px);
        overflow-y: auto;
        padding: 0 20px 20px 20px;
        .equip-wrap {
          position: relative;
          cursor: pointer;
          margin-top: 10px;
          border-bottom: 1px solid #e1e2e6;
          padding-bottom: 10px;
          display: flex;
          align-items: center;
          .left-con {
            margin-right: 20px;
            width: 80px;
            height: 80px;
            border-radius: 6px;
            overflow: hidden;
          }
          .right-con {
            font-size: 12px;
            line-height: 23px;
            .title {
              color: black;
              font-size: 15px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 170px;
            }
            .address {
              width: 260px;
              overflow: hidden; //超出文本隐藏
              white-space: nowrap;
              text-overflow: ellipsis; ///超出部分省略号显示
            }
          }
        }
        .equip-wrap:first-child {
          margin-top: 0;
        }
      }
    }
  }
}

@media (max-width: 1450px) {
  .search-area {
    left: 432px;
  }
}
</style>
